var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import s from './tabGroup.module.scss';
export var TabGroup = function (_a) {
    var choices = _a.choices, onChange = _a.onChange;
    var _b = useState([]), selectedTabs = _b[0], setSelectedTabs = _b[1];
    var toggleTab = function (choice) {
        var isSelected = selectedTabs.includes(choice);
        var newSelected = isSelected
            ? selectedTabs.filter(function (c) { return c !== choice; })
            : __spreadArray(__spreadArray([], selectedTabs, true), [choice], false);
        setSelectedTabs(newSelected);
        onChange === null || onChange === void 0 ? void 0 : onChange(newSelected);
    };
    return (_jsx("div", { className: s.tabGroup, children: choices.map(function (choice) { return (_jsx("div", { className: "".concat(s.tab, " ").concat(selectedTabs.includes(choice) ? s.tab_active : ''), onClick: function () { return toggleTab(choice); }, children: choice }, choice)); }) }));
};
